import React from 'react';
import { Save } from 'lucide-react';
import Modal from '../../../shared/components/Modal';
import FormField from '../../../shared/components/FormField';
import Button from '../../../shared/components/Button';
import { formFields, displayConfig } from '../config/masterDataConfig';
import { useMasterDataForm } from '../hooks/useMasterDataForm';

const MasterDataForm = ({
  type,
  isOpen,
  onClose,
  onSubmit,
  initialData = null,
  title,
}) => {
  const config = displayConfig[type];
  const fields = formFields[type] || [];

  const {
    register,
    handleSubmit,
    errors,
    touchedFields,
    isSubmitting,
    setValue,
    watch,
    options, // 👈 dynamic options
  } = useMasterDataForm(type, fields, initialData, onSubmit, onClose);

  /**
   * Safe options getter (NO mutation)
   */
  const getFieldOptions = (field) => {
    return options[field.name] || field.options || [];
  };

  /**
   * Render Field
   */
  const renderField = (field) => {
    const fieldError = errors[field.name];
    const isTouched = touchedFields[field.name];

    if (field.condition && !field.condition(watch())) return null;

    let fieldType = field.type;

    // relation → select
    if (field.type === 'relation') {
      fieldType = 'select';
    }

    return (
      <FormField
        key={field.name}
        label={field.label}
        name={field.name}
        type={fieldType}
        required={field.required}
        options={getFieldOptions(field)}
        rows={field.rows}
        step={field.step}
        placeholder={field.placeholder}
        helperText={field.helperText}
        icon={field.icon}
        error={fieldError?.message}
        touched={isTouched}
        {...register(field.name)}
      />
    );
  };

 return (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={
      title ||
      (initialData
        ? `Edit ${config?.title}`
        : `Add New ${config?.title}`)
    }
    size="xl" // 👈 increase size if needed
  >
    {/* Wrapper with fixed height */}
    <div className="flex flex-col max-h-[85vh]">

      {/* 🔽 SCROLLABLE FORM BODY */}
      <form
        onSubmit={handleSubmit}
        className="flex-1 overflow-y-auto px-4 py-2 space-y-4"
      >
        <div className="grid grid-cols-2 gap-4">
          {fields.map(field => (
            <div
              key={field.name}
              className={
                field.colSpan
                  ? `col-span-${field.colSpan}`
                  : 'col-span-1'
              }
            >
              {renderField(field)}
            </div>
          ))}
        </div>
      </form>

      {/* 🔽 FIXED FOOTER */}
      <div className="flex justify-end space-x-3 p-4 border-t bg-white sticky bottom-0">
        <Button
          type="button"
          variant="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          type="submit"
          variant="primary"
          icon={Save}
          isLoading={isSubmitting}
          onClick={handleSubmit}
        >
          {initialData ? 'Update' : 'Create'}
        </Button>
      </div>

    </div>
  </Modal>
);
};

export default MasterDataForm;